import Icon from './src/controls/icon';
import Register from './src/controls/register';
import './src/index.css';
export { Icon, Register };
